var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "exception" }, [
    _c("div", { staticClass: "imgBlock" }, [
      _c("div", {
        staticClass: "imgEle",
        style: { backgroundImage: `url(${_vm.config[_vm.type].img})` },
      }),
    ]),
    _c("div", { staticClass: "content" }, [
      _c("h1", [_vm._v(_vm._s(_vm.config[_vm.type].title))]),
      _c("div", { staticClass: "desc" }, [
        _vm._v(_vm._s(_vm.config[_vm.type].desc)),
      ]),
      _c("div", { staticClass: "desc" }, [
        _c(
          "span",
          { staticStyle: { "font-size": "35px", "font-weight": "bold" } },
          [_vm._v(_vm._s(this.timerCount))]
        ),
        _vm._v(" 秒后自动返回登录页 "),
      ]),
      _c(
        "div",
        { staticClass: "actions" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.handleToHome },
            },
            [_vm._v("返回登录")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }